export default __webpack_public_path__ + "static/media/(2).8391a3e8.jpg";